import { LINKS } from "src/common/constants";
import { DocumentI } from "src/types/Document";
import { LinkI } from "src/types/Link";
import { LinksAction } from "../reducers/links";

export const LINKS_SET_DATA = `${LINKS}_SET_DATA` as const;

export const setLinks = (payload: (DocumentI | LinkI)[]): LinksAction => ({
  type: LINKS_SET_DATA,
  payload,
});
